import { render, staticRenderFns } from "./PreviewTermsOfUse.vue?vue&type=template&id=93b0c4f2&scoped=true&"
import script from "./PreviewTermsOfUse.vue?vue&type=script&lang=js&"
export * from "./PreviewTermsOfUse.vue?vue&type=script&lang=js&"
import style0 from "./PreviewTermsOfUse.vue?vue&type=style&index=0&id=93b0c4f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b0c4f2",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VBtn,VResponsive})


/* hot reload */
if (module.hot) {
  var api = require("/builds/iaai/products/maturity-assessment-tool/mat-website/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93b0c4f2')) {
      api.createRecord('93b0c4f2', component.options)
    } else {
      api.reload('93b0c4f2', component.options)
    }
    module.hot.accept("./PreviewTermsOfUse.vue?vue&type=template&id=93b0c4f2&scoped=true&", function () {
      api.rerender('93b0c4f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PreviewTermsOfUse.vue"
export default component.exports